export default __webpack_public_path__ + "static/media/profilePicture.051d572a.jpg";